// extracted by mini-css-extract-plugin
module.exports = {"LatestPosts":"LatestPosts_LatestPosts__nV8F3","cta":"LatestPosts_cta__EqrkY"};